// extracted by mini-css-extract-plugin
export default {"container":"mobileApp_container__M2xir"};